function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.788,42.896c0,1.657,1.343,3,3,3h39.528c1.657,0,3-1.343,3-3s-1.343-3-3-3H20.788 C19.131,39.896,17.788,41.238,17.788,42.896"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.316,58H20.788c-1.657,0-3,1.343-3,3s1.343,3,3,3h39.528c1.656,0,3-1.343,3-3S61.973,58,60.316,58"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.316,76.104H20.788c-1.657,0-3,1.343-3,3s1.343,3,3,3h39.528c1.656,0,3-1.343,3-3 S61.973,76.104,60.316,76.104"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.104,0H23c-0.201,0-0.399,0.021-0.594,0.06c-0.133,0.027-0.256,0.073-0.382,0.116 c-0.059,0.021-0.121,0.031-0.178,0.056c-0.14,0.059-0.27,0.135-0.398,0.213c-0.037,0.022-0.08,0.038-0.116,0.063 c-0.164,0.11-0.316,0.234-0.455,0.374L0.88,20.877c-0.139,0.139-0.264,0.291-0.373,0.455c-0.028,0.042-0.047,0.091-0.073,0.135 c-0.074,0.123-0.147,0.246-0.203,0.38c-0.026,0.063-0.039,0.133-0.061,0.197c-0.041,0.119-0.085,0.236-0.11,0.362 C0.021,22.601,0,22.799,0,23v74c0,1.657,1.343,3,3,3h75.104c1.657,0,3-1.343,3-3V3C81.104,1.343,79.762,0,78.104,0 M20,10.243V20 h-9.759L20,10.243z M75.104,94H6V26h17c1.656,0,3-1.343,3-3V6h49.104V94z"
});

var SvgDocumento = function SvgDocumento(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 101,
    viewBox: "-0.354 -0.359 82 101",
    enableBackground: "new -0.354 -0.359 82 101",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocumento, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documento.905f3dc5.svg";
export { ForwardRef as ReactComponent };